<template>
  <div>
    <h3 class="boss-joboffer-title boss-setting">
      {{ title }}
    </h3>
    <div class="boss-table-2">
      <template-form
        label="自動送信利用設定"
        is-required
      >
        <div class="pega-relative">
          <div class="pega-width-40 pega-auto-reply-item-area">
            <div
              v-for="(whetherToUse, i) in autoReplyOptions.whetherToUses"
              :key="i"
            >
              <label class="pega-badge-radio pega-mr-5">
                <input
                  v-model="autoReplySetting.isAvailableAutoReplyMail"
                  :value="whetherToUse.value"
                  type="radio"
                  :data-test="`use-auto-reply-radio${i}`"
                >
                <span
                  class="pega-badge-radio-text pega-badge-radio-check-mark"
                  :data-test="`use-auto-reply-label${i}`"
                >{{ whetherToUse.label }}</span>
              </label>
            </div>
          </div>
          <div class="pega-width-60 pega-annotation-text-padding">
            <div>
              <a
                href="/help/guide.pdf"
                target="_blank"
              >
                応募受付自動送信機能とは？
              </a>
            </div>
          </div>
        </div>
      </template-form>
      <template-form
        label="送信対象設定"
        is-required
      >
        <div class="pega-relative">
          <div class="pega-width-40 pega-auto-reply-item-area">
            <div
              v-for="(allReply, i) in autoReplyOptions.allReplies"
              :key="i"
            >
              <label class="pega-badge-radio pega-mr-5">
                <input
                  v-model="autoReplySetting.isNoAutoReplyForScoutEntry"
                  :value="allReply.value"
                  type="radio"
                  :data-test="`auto-reply-target-radio${i}`"
                >
                <span
                  class="pega-badge-radio-text pega-badge-radio-check-mark"
                  :data-test="`auto-reply-target-label${i}`"
                >{{ allReply.label }}</span>
              </label>
              <small
                v-if="allReply.note"
                :data-test="`auto-reply-target-note${i}`"
              >{{ allReply.note }}</small>
            </div>
          </div>
          <div class="pega-width-60 pega-annotation-text-padding">
            <div>■ スカウトメールをご利用されている場合</div>
            <div>
              ・スカウト応募者に対して応募受付メッセージを自動送信したくない場合は除外設定が可能です。
            </div>
            <slot name="scoutMailNote">
              <div>
                例）すぐに面接案内をしたい/スカウト応募者には特別な対応をしたい
                など
              </div>
            </slot>
            <div>
              ※ただし、スカウト応募者限定の応募受付メッセージの設定はできませんので、個別の対応をお願い致します
            </div>
          </div>
        </div>
      </template-form>
      <template-form
        label="送信時間設定"
        is-required
      >
        <div class="pega-relative">
          <div class="pega-width-40 pega-auto-reply-item-area">
            <div
              v-for="(sendSchedulingTime, i) in autoReplyOptions.sendSchedulingTimes"
              :key="i"
              class="pega-relative"
            >
              <div>
                <label class="pega-badge-radio pega-mr-5">
                  <input
                    v-model="autoReplySetting.isSchedulingSending"
                    :value="sendSchedulingTime.value"
                    type="radio"
                    :data-test="`sending-status-radio${i}`"
                  >
                  <span
                    class="pega-badge-radio-text pega-badge-radio-check-mark"
                    :data-test="`sending-status-label${i}`"
                  >{{ sendSchedulingTime.label }}</span>
                </label>
              </div>
              <div>
                <template v-if="sendSchedulingTime.value">
                  <label
                    v-for="(autoReplyMailScheduleOption, j) in autoReplyMailScheduleOptions"
                    :key="j"
                    class="boss-checkbox pega-label-margin"
                    :data-test="`sending-time-label-${i}-${autoReplyMailScheduleOption.id}`"
                  >
                    <input
                      v-model="autoReplySetting.sendingTimes"
                      :value="autoReplyMailScheduleOption.id"
                      class="boss-input-checkbox"
                      type="checkbox"
                      :data-test="`sending-time-checkbox-${i}-${autoReplyMailScheduleOption.id}`"
                    >
                    {{ autoReplyMailScheduleOption.name }}時
                  </label>
                </template>
              </div>
            </div>
            <div class="boss-layout boss-layout-start">
              <span class="pega-send-time-label">※送信したい時刻にチェックをしてください（複数選択可）</span>
            </div>
          </div>
          <div class="pega-width-60 pega-annotation-text-padding">
            <div>■ 送信時間の設定について</div>
            <div>
              ・応募頂いたタイミングでの即時送信か時間指定のいずれかを選択できます。
            </div>
          </div>
        </div>
      </template-form>
      <template-form
        label="件名"
        is-required
      >
        <div class="pega-relative">
          <div class="pega-width-40 pega-auto-reply-item-area">
            <small>（150文字以内）</small>
            <input
              v-model="autoReplySetting.mailSubject"
              class="boss-send-subject"
              type="text"
              data-test="mail-subject"
            >
          </div>
        </div>
      </template-form>
      <template-form
        label="本文"
        is-required
      >
        <div class="pega-relative">
          <div class="pega-width-40 pega-auto-reply-item-area">
            <small>（2,000文字以内）</small>
            <div class="boss-textarea-button pega-relative">
              <span
                class="boss-button boss-button-compact"
                data-test="user-name"
                @click="insertionValue('■USER_NAME■ 様')"
              >応募者名を挿入</span>
              <span style="font-size: 0.8125rem; padding: 4px 0">（本文にのみ有効）</span>
            </div>
            <textarea
              ref="message"
              v-model="autoReplySetting.mailText"
              data-test="mail-text"
              class="boss-send-textarea"
              rows
              cols
            />
          </div>
          <div class="pega-width-60 pega-annotation-text-padding">
            <div>■メッセージ作成について</div>
            <div class="margin-top-1">
              応募者名挿入機能の使い方
            </div>
            <div>
              ・本文にカーソルを合わせ、〔応募者名を挿入〕のボタンをクリックすると、≪
              ■USER_NAME■ 様 ≫ と挿入されます。
            </div>
            <div>・メッセージ送信時に自動的に応募者名に変換されます。</div>
            <div>
              ・ボタンを使用せずに、■USER_NAME■と直接記入して頂いても自動変換されますが、敬称がつきませんので、ご注意ください。
            </div>
            <div class="margin-top-1">
              ■送信前にご確認いただきたいこと
            </div>
            <slot name="beforeSendingNote">
              <div class="pega-annotation-container margin-top-1">
                <div>・応募後の選考プロセスや選考期間を明記していますか？</div>
                <div>
                  ※選考方法や期間を明記することで応募者に安心感を与えることができます。
                </div>
                <div class="margin-top-1">
                  例)
                </div>
                <div>「書類選考には1週間～10日程度お時間を頂いております。」</div>
                <div>
                  「弊社では、web応募書類/履歴書/職務経歴書をもとに選考しております。
                </div>
                <div>
                  お手数ではございますが、下記宛先に履歴書と職務経歴書をご送付頂けますでしょうか。
                </div>
                <div>
                  なお、書類選考には書類到着から1～2週間ほどお時間を頂いております。」
                </div>
                <div class="margin-top-1">
                  ・不採用時の連絡の有無を明記していますか？
                </div>
                <div>※不採用の場合もご連絡することをお勧めしています。</div>
                <div class="margin-top-1">
                  例）
                </div>
                <div>「選考の結果は、合否に関わらずご連絡致します。」</div>
                <div>
                  「選考の結果は、書類選考を通過された方にのみご連絡致します。」
                </div>
              </div>
            </slot>
          </div>
        </div>
      </template-form>
      <template-form label="署名">
        <div class="pega-width-40 pega-auto-reply-item-area">
          <small>（400文字以内）</small>
          <textarea
            v-model="autoReplySetting.mailSignature"
            data-test="mail-signature"
            class="pega-signature-textarea"
            rows
            cols
          />
        </div>
      </template-form>
    </div>
    <div class="margin-top-1 pega-flex-center">
      <button
        data-test="register-button"
        class="boss-button boss-button-confirm pega-button"
        @click="registerAutoReplySetting()"
      >
        <span
          class="boss-button-confirm-text"
          data-test="confirm-button"
        >
          上記内容で保存</span>
      </button>
    </div>
  </div>
</template>

<script>
import TemplateForm from '@/components/atoms/TemplateForm'
import { applicantAutoReplyOptions } from '@/lib/labelValueMappings'
import { mapGetters } from 'vuex'
import _ from 'lodash'

const DEFAULT_MAIL_TEXT = `■USER_NAME■ 様

この度は、弊社求人にご応募いただきまして誠にありがとうございます。

これから、お送りいただいた応募内容を拝見させていただきます。
1週間から10日間程で改めてご連絡申し上げますので、今しばらくお待ちくださいますようお願い致します。

※本メールはご応募いただいた方への自動返信メールです。予めご了承下さい。
`

export default {
  components: {
    TemplateForm
  },
  props: {
    title: {
      default: '応募受付メッセージ自動送信設定',
      type: String
    },
    defaultMailSubject: {
      default: 'ご応募ありがとうございます',
      type: String
    },
    defaultMailText: {
      default: DEFAULT_MAIL_TEXT,
      type: String
    },
    settingApiUrl: {
      default: '/settings/entry_message_auto_reply',
      type: String
    }
  },
  data () {
    return {
      autoReplyOptions: applicantAutoReplyOptions,
      autoReplySetting: {
        id: '',
        isAvailableAutoReplyMail: false,
        isNoAutoReplyForScoutEntry: false,
        isSchedulingSending: false,
        sendingTimes: [],
        mailSubject: '',
        mailText: '',
        mailSignature: null
      }
    }
  },
  computed: {
    ...mapGetters({
      autoReplyMailScheduleOptions: 'autoReplyMailSchedulesMaster'
    }),
    requestParam () {
      return {
        id: this.autoReplySetting.id,
        isAvailableAutoReplyMail: this.autoReplySetting.isAvailableAutoReplyMail,
        isNoAutoReplyForScoutEntry: this.autoReplySetting.isNoAutoReplyForScoutEntry,
        isSchedulingSending: this.autoReplySetting.isSchedulingSending,
        sendingTimes: _.sortBy(this.autoReplySetting.sendingTimes),
        mailSubject: this.autoReplySetting.mailSubject,
        mailText: this.autoReplySetting.mailText,
        mailSignature: this.autoReplySetting.mailSignature
      }
    }
  },
  created () {
    this.fetchAutoReplySetting()
  },
  methods: {
    fetchAutoReplySetting () {
      this.$http.secured.get(this.settingApiUrl).then(response => {
        const settings = response.data
        this.$set(this.autoReplySetting, 'id', settings.id)
        this.$set(this.autoReplySetting, 'isAvailableAutoReplyMail', settings.isAvailableAutoReplyMail)
        this.$set(this.autoReplySetting, 'isNoAutoReplyForScoutEntry', settings.isNoAutoReplyForScoutEntry)
        this.$set(this.autoReplySetting, 'isSchedulingSending', settings.isSchedulingSending)
        this.$set(this.autoReplySetting, 'sendingTimes', settings.sendingTimes)
        this.setMailSubject(settings.mailSubject)
        this.setMailText(settings.mailText)
        this.$set(this.autoReplySetting, 'mailSignature', settings.mailSignature)
      })
    },
    setMailSubject (mailSubject) {
      const setSubject = !_.isEmpty(mailSubject) ? mailSubject : this.defaultMailSubject
      this.$set(this.autoReplySetting, 'mailSubject', setSubject)
    },
    setMailText (mailText) {
      const setText = !_.isEmpty(mailText) ? mailText : this.defaultMailText
      this.$set(this.autoReplySetting, 'mailText', setText)
    },
    registerAutoReplySetting () {
      if (this.requestParam.id == null) {
        this.$http.secured.post(this.settingApiUrl, this.requestParam).then(() => {
          this.settingResponse()
        })
      } else {
        this.$http.secured.put(this.settingApiUrl, this.requestParam).then(() => {
          this.settingResponse()
        })
      }
    },
    settingResponse () {
      this.$toasted.global.success({ message: '設定内容を保存しました。' })
      this.$router.push({ name: 'dashboardTop' })
    },
    insertionValue (value) {
      const cursorPosition = this.$refs.message.selectionStart
      this.$set(this.autoReplySetting, 'mailText', this.autoReplySetting.mailText.substr(0, cursorPosition) + value + this.autoReplySetting.mailText.substr(cursorPosition, this.autoReplySetting.mailText.length))
    }
  }
}
</script>
